import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUser, logoutUser } from '../actions/firebase_actions';
import NavLink from 'components/helpers/navLink';

class App extends Component {

    constructor(props) {
        super(props);

        this.props.fetchUser();
    }

    logOut = () => {
        this.props.logoutUser().then(data => {
            // reload props from reducer
            this.props.fetchUser();
        });
    }

    renderUserMenu(currentUser) {
        // if current user exists and user id exists than make user navigation
        if (currentUser && currentUser.uid) {
            return [
                <li className="nav-item dropdown" key={2}>
                    <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                         aria-haspopup="true" aria-expanded="false">
                        <img className="user-avatar" src={currentUser.photoURL} />
                        <span>
                            {currentUser.displayName}
                        </span>
                        <span className="caret"></span>
                    </a>
                    <div className="dropdown-menu">
                        <Link className="dropdown-item" to="/profile"><i className="fa fa-user"></i> Profile</Link>
                        <Link className="dropdown-item" to="/edit"><i className="fa fa-pencil-square-o"></i> Edit Trip</Link>
                        <Link className="dropdown-item" to="/checkin"><i className="fa fa-paper-plane-o"></i> Check-in</Link>
                        <div role="separator" className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/" onClick={ this.logOut }><i className="fa fa-lock"></i> Logout</Link>
                    </div>
                </li>
            ];
        }
        else {
            return null;
        }

    }

    render() {
        return (
            <div>
                <nav className="navbar navbar-fixed-top navbar-light bg-faded" role="banner">
                    <Link to="/" className="navbar-brand" activeClassName="active"><i className="fa fa-map-o"></i> Walkabout</Link>

                    <button className="navbar-toggler hidden-sm-up float-xs-right"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarResponsive"
                            aria-controls="navbarResponsive"
                            aria-expanded="false"
                            aria-label="Toggle navigation"></button>

                    <div className="collapse navbar-toggleable-xs" id="navbarResponsive">
                        <ul className="nav navbar-nav">
                            <NavLink to="/itinerary">Itinerary</NavLink>
                            <NavLink to="/journal">Journal</NavLink>
                        </ul>

                        <ul className="nav navbar-nav float-sm-right">
                            { this.renderUserMenu(this.props.currentUser) }
                        </ul>
                    </div>
                </nav>

                <main className="app">
                    {this.props.children}
                </main>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchUser, logoutUser }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/app/components/app.jsx